import { render, staticRenderFns } from "./main-product.vue?vue&type=template&id=39b55d21&scoped=true&"
import script from "./main-product.vue?vue&type=script&lang=js&"
export * from "./main-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b55d21",
  null
  
)

export default component.exports